// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"ff250999","455":"2c7246a0","977":"c20f332c"}[chunkId] + ".chunk.js";
};